import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VContainer,{attrs:{"fill-height":"","fluid":"","grid-list-xl":""}},[_c(VFlex,[(_vm.protocol.id)?_c('app-upsert',{attrs:{"config":_vm.config,"item":_vm.hiddenFields,"title":_vm.protocol && _vm.protocol.name},on:{"saved":_vm.saved}}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }